import React, {useContext, useEffect} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {Grid} from "@mui/material";

import CustomButton from "components/CustomButton";
import WmsItemInformation from "components/WMS/Mobile/WmsItemInformation/WmsItemInformation";

import {packingStepNames} from "../../packingSteps";

import {PackingContext} from "../../PackingContext";

WmsItemInformationPacking.propTypes = {
    lineItem: PropTypes.object.isRequired,
    packingStep: PropTypes.object.isRequired,
    beginPacking: PropTypes.func.isRequired,
    beginShipmentWeigh: PropTypes.func.isRequired,
    handleClose: PropTypes.func,
    handleProductCancelled: PropTypes.func,
};

function WmsItemInformationPacking({lineItem, packingStep, beginPacking, beginShipmentWeigh, handleProductCancelled, handleClose}) {
    const {setOpenProductProblemDrawer, handleAllItemAreCancelled, handlePackItem, packingLoading} = useContext(PackingContext);


    const areAllItemsPackedOrCancelled = packingStep.selectedShipment.lineItems
        .every(item => item.isPacked || item.isCancelled)
    ;

    const itemsWithSameEan = packingStep.selectedShipment.lineItems
        .filter(item => item.eanCode === lineItem.eanCode)
    ;

    const areAllItemsWithSameEanPackedOrCancelled = itemsWithSameEan
        .every(item => item.isPacked || item.isCancelled)
    ;

    const totalItemsCount = itemsWithSameEan.filter(item => !item.isCancelled).length;
    const packedItemsCount = itemsWithSameEan.filter(item => item.isPacked).length;

    useEffect(() => {
        if (
            packingStep.selectedShipment.isMulti &&
            totalItemsCount &&
            packedItemsCount &&
            0 < totalItemsCount &&
            !lineItem.isCancelled &&
            packedItemsCount === totalItemsCount
        ) {
            handleClose()
        }
    }, [packedItemsCount, packingStep, totalItemsCount, handleClose]);

    return (
        <WmsItemInformation wmsItem={lineItem.wmsItem}>
            <Grid container direction={"column"} gap={"16px"}>
                {packingStep.stepName === packingStepNames.PEEK && (
                    <CustomButton fullWidth onClick={beginPacking}>
                        {/* Scan workstation */}
                        <FormattedMessage id={"wms.packing.item.button.beginPacking"}/>
                    </CustomButton>
                )}
                {packingStep.stepName === packingStepNames.PACK_ITEMS && !lineItem.isCancelled && (
                    <CustomButton
                        fullWidth
                        onClick={areAllItemsPackedOrCancelled ? beginShipmentWeigh : () => handlePackItem(lineItem.wmsItem.barcode)}
                        disabled={packingLoading}
                    >
                        {/* Scan workstation */}
                        {areAllItemsPackedOrCancelled ? (
                            <FormattedMessage id={"wms.packing.item.startWeighingShipment"}/>
                        ) : (
                            <>
                                <FormattedMessage id={"wms.packing.item.manualConfirm"}/>
                                {packingStep.selectedShipment.isMulti && (
                                    <span>&nbsp;({packedItemsCount}/{totalItemsCount})</span>
                                )}
                            </>
                        )}
                    </CustomButton>
                )}
                {!lineItem.isCancelled && (
                    <CustomButton
                        color={"red"}
                        fullWidth
                        variant={'nude'}
                        onClick={() => setOpenProductProblemDrawer({
                            isOpen: true,
                            product: lineItem,
                            handleProductCancelled: handleProductCancelled ?? handleAllItemAreCancelled
                        })}
                    >
                        <FormattedMessage id={"wms.packing.productProblem.title"}/>
                    </CustomButton>
                )}
            </Grid>
        </WmsItemInformation>
    );
}

export default WmsItemInformationPacking;
